<details-section [showDetails]="false">
  <ng-container slot="header">
    <div class="sessions-header">
      <div class="sessions-title-container">
        <span class="sessions-title">{{ 'reportingV2.SESSIONS' | transloco }}</span>
      </div>
      <div class="sessions-actions">
        <span class="sessions-count">{{ totalSessionsCount() }} {{ 'TOTAL' | transloco }}</span>
        <button class="download-btn" (click)="onDownloadClick()">
          <qai-icon [kind]="'download'" [size]="'20px'"></qai-icon>
        </button>
      </div>
    </div>
  </ng-container>

  <qai-table
    [headers]="headers"
    [data]="tableData"
    [striped]="false"
    [currentPage]="currentPage"
    [showPagination]="true"
    [showTimeInDateDisplay]="true"
    [pageSize]="10"
    (pageChanged)="onPageChanged($event)"
    [noDataMessage]="'reportingV2.No_SIMULATION' | transloco"
    [previousLabel]="'reportingV2.PAGINATION_PREVIOUS' | transloco"
    [nextLabel]="'reportingV2.PAGINATION_NEXT' | transloco"
  ></qai-table>
</details-section>

